module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMS4yNSA2Ljc4NTY0SDYuNzVWMTEuMjg1Nkg1LjI1VjYuNzg1NjRIMC43NVY1LjI4NTY0SDUuMjVWMC43ODU2NDVINi43NVY1LjI4NTY0SDExLjI1VjYuNzg1NjRaIiBmaWxsPSIjNDg4NDkyIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/addblue.svg
// module id = 0i+e
// module chunks = 1